export default __webpack_public_path__ + "static/media/logo.caf7ea46.png";